import React, { useMemo } from "react";
import { Card, CardBody } from "reactstrap";
import { useHistory } from "react-router-dom";

/*
Expected task object (example):
{
  taskId: number,
  taskName: string,
  workDate: string,
  updatedAt: string,
  timeSheetStatus: number   // 2 = Pending
}
*/

const MyTasks = ({ tasks = [] }) => {
  const history = useHistory();

  // 🔹 Deduplicate + latest 10 pending tasks
  const pendingTasks = useMemo(() => {
    const taskMap = new Map();

    tasks.forEach(task => {
      if (task.timeSheetStatus !== 2) return;

      const key = task.employeeTimeSheetId;

      if (!taskMap.has(key)) {
        taskMap.set(key, task);
      } else {
        const existing = taskMap.get(key);
        if (
          new Date(task.workDate) > new Date(existing.workDate)
        ) {
          taskMap.set(key, task);
        }
      }
    });

    return Array.from(taskMap.values())
      .sort(
        (a, b) =>
          new Date(b.workDate) - new Date(a.workDate)
      )
      .slice(0, 10);
  }, [tasks]);

  // 🔹 SAME navigation logic as Edit icon
  const handleEditRedirect = (taskId) => {
    history.push(`/taskManagment`);
  };

  return (
    <Card className="h-100 shadow-sm">
      <CardBody>
        {/* Header */}
       <div className="d-flex justify-content-between align-items-start mb-3">
  
  {/* LEFT SIDE – Icon + Title */}
  <div className="d-flex align-items-start gap-3">
    <div className="icon-box bg-success-light">
      <i className="fas fa-tasks text-success"></i>
    </div>

    <div>
      <h5 className="mb-1 fw-semibold">My Tasks</h5>
      <p className="text-muted small mb-0">
       Latest Pending Tasks
      </p>
    </div>
  </div>

  {/* RIGHT SIDE – Count Badge */}
  <span className="badge bg-success fs-6 px-3 py-2">
    {pendingTasks.length}
  </span>

</div>


        {/* Task List */}
        <ul className="list-unstyled mt-3 mb-0">
          {pendingTasks.length === 0 && (
            <li className="text-muted text-center py-3">
              🎉 No pending tasks
            </li>
          )}

          {pendingTasks.map(task => (
            <li
              key={task.taskId}
              className="mb-3 task-item"
              style={{
                cursor: "pointer",
                padding: "6px 4px"
              }}
              onClick={() =>
                handleEditRedirect(task.taskId)
              }
            >
              <div className="fw-medium text-primary">
                {task.issueTitle}
              </div>

              <small className="text-muted">
                Worked on{" "}
                {new Date(task.workDate).toLocaleDateString()}
              </small>
            </li>
          ))}
        </ul>
      </CardBody>
    </Card>
  );
};

export default MyTasks;
